module.exports = __webpack_public_path__ + "20ff976edd8ceaf0854ce9015d4f96b0.jpg";